// import Certificado from './Index.vue'
import Permissions from "../../models/Permissions";

const SpedContribuicoes = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

const meta = {
  requiresAuth: true,
  requiresCompany: true,
  showInMenu: true,
  label: "SPED Contribuições",
  icon: "fa fa-file-o",
  group: "SPEDS / DeSTDA",
  permissions,
};

export default [
  {
    path: "/SpedContribuicoes",
    name: "SpedContribuicoes",
    component: SpedContribuicoes,
    meta,
  },
];
